import {Layers, WalkOfShameLayers} from "./WalkOfShameLayers";
import {WalkOfShameGameConfig} from "../WalkOfShameGameConfig";
import {WalkOfShame} from "../WalkOfShame";

export class WalkOfShameSymbolCount extends PIXI.Container {
    private _allItems: PIXI.Sprite[][] = [];

    constructor() {
        super();

        WalkOfShameLayers.getLayer(Layers.SYMBOL_COUNT)?.addChild(this);
        this.init();
    }

    public showItem(reel: number, row: number): void {
        if (reel === 0 && row > 2) {
            return;
        }

        const item: PIXI.Sprite = this._allItems[reel][row];

        item.visible = true;
    }

    public hideAll(): void {
        this._allItems.forEach((items: PIXI.Sprite[]) => {
            items.forEach((item: PIXI.Sprite) => {
                item.visible = false;
                item.tint = 0xffffff;
            });
        });
    }

    public tintItemToNoWin(reel: number, row: number): void {
        if (reel === 0 && row > 2) {
            return;
        }

        const item: PIXI.Sprite = this._allItems[reel][row];
        item.tint = 0x555555;
    }

    private init(): void {
        let item: PIXI.Sprite;
        const symWidth: number = 144,
            symHeight: number = 148;

        for (let reel: number = 0; reel < WalkOfShameGameConfig.REELS_NUM; reel++) {
            const baseY: number = (reel === 0 ? 162 : 89);
            this._allItems.push([]);

            for (let row: number = 0; row < 4; row++) {
                item = new PIXI.Sprite(WalkOfShame.assetLoader.getTextures("multipliers/x2")[0]);
                item.visible = false;
                item.anchor.set(0.5);
                item.scale.set(0.85);
                item.rotation = 0.5;
                item.x = ((reel * symWidth) + (symWidth - item.width / 2));
                item.y = ((row * symHeight) + baseY + symHeight - (item.height / 2.5) - 5);

                this._allItems[reel].push(item);
                this.addChild(item);
            }
        }
    }
}